import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import $ from "jquery";
// import QrCode from "../../../../";
import axios from 'axios';   
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { QRCodeSVG  } from 'qrcode.react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import DatePicker, { DateObject } from "react-multi-date-picker";
import { useNavigate } from 'react-router-dom';

const CorporatePayment = ({ show, onClose , order }) => {
    console.log(order);

    const options_payment_mode = [
        { value: "1", label: "Paypal" },
        { value: "3", label: "Paytm" },
        { value: "4", label: "Google Pay" },
        { value: "5", label: "Bank" },
        { value: "6", label: "Cash" },
    ];

    const tableRef = useRef(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const [endDate, setEndDate] = useState(new Date());
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [cateringType, setCateringType] = useState([]);
    const [functionType, setFunctionType] = useState([]);
    const [mealsPeriod, setMealsPeriod] = useState([]);
    const [orders, setOrders] = useState([]);   
    const [gst_percentage, setGstPercentage] = useState(0); 
    const qrContainerRef  = useRef(null); 
    let upiURL;

    if (typeof order.payment_url === 'string') {
    upiURL = JSON.parse(order.payment_url);
    } else {
    upiURL = order.payment_url;
    } 
    const [collectedAmount, setCollectedAmount] = useState('');
    const [collectedDate, setCollectedDate] = useState(null);

    const [isVisible, setIsVisible] = useState();
    const handlePaymentModeChange = (selected) => {
        setSelectedOption(selected);
        setIsVisible(selected.value !== "6");
    };
    const navigate = useNavigate();


    const getGST = () => {
        axios.get(`${BaseUrl}/generalSetting/1`)
            .then(response => {
                if (response.data && response.data.data) {
                    setGstPercentage(parseFloat(response.data.data.gst));
                } else {
                    console.log("Unexpected API response structure:", response);
                    setGstPercentage(5);
                }
            })
            .catch(error => {
                console.log("Failed to fetch general settings:", error);
                setGstPercentage(5);
            });
    }


    const fetchOrders = async () => {
    try {
        const response = await axios.get(`${BaseUrl}/manage_order/list`);
        const data = response.data;
        setOrders(Array.isArray(data) ? data : []);
    } catch (error) {
        setOrders([]);
        toast.error('Failed to fetch orders');
    }
    };

    useEffect(() => {
    fetchOrders();
    getGST();
    }, []);

        const fetchCateringType = async () => {
            try {
                    const response = await axios.get(`${BaseUrl}/cateringtype/getactive`);
                    if (response.data && Array.isArray(response.data)) {
                        const formatted = response.data.map(item => ({
                            value: String(item.sno),
                            label: item.catering_type
                        }));
                        setCateringType(formatted);
                        console.log(formatted);
                    }
                } catch (error) {
                    console.error('Failed to fetch Catering Type:', error);
                    setCateringType([]);
                }
        };
    
        const getCateringTypeLabel = (sno) => {
            if (!Array.isArray(cateringType)) return '';
            const found = cateringType.find(ct => ct.value === String(sno));
            return found?.label || '';
        };
    
        const fetchitemSchedule = async () => {
                try {
                    const response = await axios.get(`${BaseUrl}/item-schedule/items/active`);
                    
                    const list = response.data?.data;
            
                    if (Array.isArray(list)) {
                    const formatted = list.map(item => ({
                        value: String(item.sno),
                        label: item.itemschedule_name
                    }));
                    setMealsPeriod(formatted);
                    } else {
                    setMealsPeriod([]); // fallback to empty array
                    }
                } catch (error) {
                    console.error('Failed to fetch Meals period:', error);
                    setMealsPeriod([]); // fallback to empty array, not object
                }
        };
    
        const getMealsPeriodLabel = (sno) => {
            if (!Array.isArray(mealsPeriod)) return '';
            const found = mealsPeriod.find(mp => mp.value === String(sno));
            return found?.label || '';
        };
    
        const fetchFunctionType = async () => {
            try {
                const response = await axios.get(`${BaseUrl}/functiontype/getactive`);
                if (response.data && Array.isArray(response.data)) {
                 const formatted = response.data.map(item => ({
                        value: String(item.sno),
                        label: item.function_type
                    }));
                    setFunctionType(formatted);
                }
            } catch (error) {
                console.error('Failed to Function Type:', error);
                setFunctionType([]);
            }
        };
    
        const getFunctionTypeLabel = (sno) => {
            if (!Array.isArray(functionType)) return '';
            const found = functionType.find(ft => ft.value === String(sno));
            return found?.label || '';
        };
    
        const formatDate = (dateStr) => {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        };

       const sendPayment = async (order_id) => {
            try {
                // Get the rendered SVG element inside the container
                const svgElement = qrContainerRef.current?.querySelector("svg");

                if (!svgElement) {
                    console.error("SVG element not found!");
                    toast.error("QR Code not generated yet.");
                    return;
                }

                // Serialize SVG to string and encode to Base64
                const svgString = new XMLSerializer().serializeToString(svgElement);
                const base64Svg = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(svgString)))}`;

                // Send the data to the backend
                const response = await axios.put(`${BaseUrl}/manage_order/update_order_status/${order_id}/5/2`, {
                    qr_code_image: base64Svg,
                });

                if (response.data?.success) {
                    toast.success("Payment Link Sent & QR Code Saved Successfully");
                    onClose();
                    navigate('/catering-payment');
                } else {
                    toast.error("Failed to update order with QR Code");
                }
            } catch (error) {
                console.error("Failed to send payment link and save QR code:", error);
                toast.error("Failed to send payment link or save QR code");
            }
        };



     useEffect(() => {
                    fetchFunctionType();
                    fetchCateringType();
                    fetchitemSchedule();
        }, []);

    useEffect(() => {
        // Add 7 days to the current date
        const nextDate = new Date();
        nextDate.setDate(nextDate.getDate() + 7);
        setEndDate(nextDate);
    }, []);

    // const paymentUrl = `${BaseUrl}/online-payment-corp?order_id=${order.payment_id}&amount=${order.total_amount}`;


    useEffect(() => {
        const tables = document.querySelectorAll('.subscription_table');
        tables.forEach((table) => {
            if (!$.fn.dataTable.isDataTable(table)) {
                $(table).DataTable({
                    "responsive": true,
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        });
    }, []);
    const [showPaymentDetails, setShowPaymentDetails] = useState(false);
    const [sendVia, setSendVia] = useState('');

    const handleSendViaChange = (e) => {
        setSendVia(e.target.value);
    };

    const urldata = {
        order_id: order.payment_id,
        amount: order.total_amount
    };
    const encoded = btoa(JSON.stringify(urldata));

const handleOfflinePayment = async () => {
    if (!collectedAmount) {
        toast.error("Please enter collected amount");
        return;
    }

    if (!collectedDate) {
        toast.error("Please select collected date");
        return;
    }

    // Normalize date to YYYY-MM-DD
    const finalDate = collectedDate 
        ? collectedDate.format
            ? collectedDate.format("YYYY-MM-DD")
            : new Date(collectedDate).toISOString().split('T')[0]
        : null;

    console.log("Offline Payment Data:", {
        order,
        payment: { payment_id: order.payment_id, amount: collectedAmount },
        date: finalDate
    });

    try {
        const response = await axios.post(`${BaseUrl}/manage_corporate_order/verify_payment`, {
            order: order,
            payment: { payment_id: order.payment_id, amount: collectedAmount },
            date: finalDate
        });

        console.log("Backend Response:", response.data);

        if (response.data?.success) {
            toast.success(response.data.message || "Payment verified successfully!");
            onClose?.();
        } else {
            toast.error(response.data.message || "Verification failed");
        }
    } catch (error) {
        console.error("Offline payment error:", error);
        toast.error(error.response?.data?.message || "An error occurred");
    }
};


    
    return (
        <Modal show={show} size="lg"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Payment</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-4">
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Order Id</label>
                            <div className='d-block'>
                                <label className='text-danger font-w600 fs-6 py-0'>{order.corp_orders?.[0]?.catering_id ?? ''}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Customer Name</label>
                            <div className='d-block'>
                                <label className='text-danger font-w600 fs-6 py-0'>{order.corp_customer?.customer_name ?? ''}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Customer Mobile No</label>
                            <div className='d-block'>
                                <label className='text-danger font-w600 fs-6 py-0'>{order.corp_customer?.customer_number ?? ''}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>  
                            <label className='text-black text-start font-w600 fs-7'>Catering Type</label>
                            <div className='d-block'>
                                <label className='text-danger font-w600 fs-6 py-0'>{getCateringTypeLabel(order.corp_orders?.[0].catering_type ?? '')}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Function Type</label>
                            <div className='d-block'>
                                <label className='text-danger font-w600 fs-6 py-0'>{getFunctionTypeLabel(order.corp_orders?.[0].function_type ?? '')}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Total Cost</label>
                            <div className='d-block'>
                                <label className='text-danger font-w600 fs-6 py-0'>₹ {order.total_amount}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Head Count</label>
                            <div className='d-block'>
                                <label className='text-white bg-primary px-2 rounded font-w600 fs-6 py-1'>{order.corp_orders?.[0].head_count ?? ''}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Payment Closing Date</label>
                            <div className='d-block'>
                                <label className='text-danger font-w600 fs-6 py-0'>{formatDate(order.corp_orders?.[0].payment_closing_date ?? '')}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Order Date</label>
                            <div className='d-block'>
                                <label className='text-danger font-w600 fs-6 py-0'>{formatDate(order.corp_orders?.[0].order_date ?? '')}</label>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className='col-lg-12 mb-2'>
                            <div className='text-center mb-4'>
                                <div className="bg-danger-light border-bottom text-black font-w600 fs-3">
                                    <label className='mb-0'>Payments Details</label>
                                </div>
                            </div>
                            <div className='row mb-2'>
                                <div className='col-lg-6 mb-2'>
                                    <div className='row mb-2'>
                                        {/* Radio Buttons */}
                                        <div className="col-lg-12 mb-4">
                                            <label className="text-black font-w500 fs-5">Send Via Whatsapp<span className="required">*</span></label>
                                            <div className='mt-2'>
                                                <div className="form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="send_via"
                                                        value="online"
                                                        checked={sendVia === 'online'}
                                                        onChange={handleSendViaChange}
                                                    />
                                                    <label className="form-check-label fs-7 font-w600 text-black">Online</label>
                                                </div>
                                                <div className="form-check-inline">
                                                    <input 
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="send_via"
                                                        value="offline"
                                                        checked={sendVia === 'offline'}
                                                        onChange={handleSendViaChange}
                                                    />
                                                    <label className="form-check-label fs-7 font-w600 text-black">Offline</label>
                                                </div>
                                            </div>
                                        </div>
                                               {sendVia === "online" && (
                                                    <div className="text-center">
                                                        <Link  to={`/online-payment?data=${encodeURIComponent(encoded)}`} target="_blank" className="btn btn-success mb-3">Open Payment Link</Link>
                                                        <div ref={qrContainerRef}>
                                                            <QRCodeSVG
                                                                value={`${window.location.origin}/online-payment?data=${encodeURIComponent(encoded)}`}
                                                                size={200}
                                                                bgColor="#ffffff"
                                                                fgColor="#000000"
                                                                level="H"
                                                                includeMargin={true}
                                                            />
                                                        </div>
                                                    </div>
                                                )} 
                    
                                                {sendVia === "offline" && (
                                                    <div className="row">
                                                        <div className="col-lg-12 mb-3">
                                                            <label>Collected Amount <span className="required">*</span></label>
                                                            <input type="text" className="form-control" placeholder="Enter Collected Amount" value={collectedAmount} onChange={(e) => setCollectedAmount(e.target.value)} />
                                                        </div>
                                                        {/* <div className="col-lg-12 mb-3">
                                                            <label>Collected Date <span className="required">*</span></label>
                                                            <DatePicker value={collectedDate} onChange={setCollectedDate} format="DD-MM-YYYY" />
                                                        </div> */}
                                                        <div className="col-lg-12 mb-3">
                                                            <label>Collected Date <span className="required">*</span></label>
                                                            <div className="datepicker-wrapper" style={{
                                                                border: "1px solid #ced4da",
                                                                borderRadius: "4px",
                                                                padding: "5px"
                                                            }}>
                                                                <DatePicker
                                                                value={collectedDate}
                                                                onChange={setCollectedDate}
                                                                format="DD-MM-YYYY"
                                                                style={{ border: "none", width: "100%" }}
                                                                />
                                                            </div>
                                                            </div>
                    
                                                    </div>
                                                )}
 
                                    </div>
                                </div>
                             
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                        {/* <Link className="btn btn-sm btn-primary"  onClick={() => sendPayment(order.id)}>Send Payment <i className="fas fa-angle-double-right ms-2"></i></Link> */}
                        <Button className="btn btn-primary" onClick={() => sendVia === 'online' ? sendPayment(order.id) : handleOfflinePayment()}>
                            Send Payment <i className="fas fa-angle-double-right ms-2"></i>
                        </Button>

                        
                    
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default CorporatePayment;
